import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { resourceContent } from '../../../constants/copyright';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import { safeHTML } from '../../../utils/safeHTML';
import { useTranslation } from '../../../translations';
import { useLanguageControls } from '../../../hooks/useLanguageControls';
import classNames from 'classnames';

const ResourceModal = React.forwardRef(function (
  { title, description, className, buttonText, buttons, hp, index, closeCallback, gtm, image, promoCode },
  ref,
) {
  const { closeModal } = useModal();
  const [showNotification, setShowNotification] = useState(false);
  const { t } = useTranslation();
  const { getLocalizedText } = useLanguageControls();

  const buttonClick = () => {
    closeCallback?.();
    closeModal({ type: 'all' });
  };

  const copyButtonClick = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(promoCode);
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 2000);
    } catch {
      console.error(`${promoCode} not copied to clipboard.`);
    }
  };

  return (
    <CustomModal className={'custom-modal_resource'} animation={['fade', 'block-scale-bounce']} isFullPage={true}>
      <div className={classNames('resource-modal', `resource-modal_${index}`, className)} ref={ref}>
        {showNotification && <div className='resource-modal__notification'>{t('other.promoCodeCopied')}</div>}
        <div className={'resource-modal__bg'} />
        <div className={'resource-modal__content'}>
          <div className={'resource-modal__block'}>
            {image && (
              <div className={'resource-modal__image'}>
                <img src={image} alt='' />
              </div>
            )}
            <div className={'resource-modal__content-block'} style={{ paddingTop: image ? 10 : undefined }}>
              <div className={'resource-modal__title'}>{safeHTML(t(title))}</div>
              {hp && (
                <div className={'resource-modal__hp'}>
                  <div className={'resource-modal__hp-title'}>{hp}</div>
                </div>
              )}
              {promoCode && (
                <div className={'resource-modal__promoCode-container'}>
                  <span className={'resource-modal__promoCode'}>{promoCode}</span>
                  <button className={'resource-modal__promoCode-button'} onClick={copyButtonClick}>
                    {t('other.copyPromoCode')}
                  </button>
                </div>
              )}
              <div className={'resource-modal__text'}>
                {safeHTML(getLocalizedText(t(description, { returnObjects: true })))}
              </div>
              {!buttons && (
                <CustomButton
                  {...resourceContent.button}
                  text={buttonText ?? resourceContent.button.text}
                  preventDefault={true}
                  stopPropagation={true}
                  gtm={gtm}
                  onClick={buttonClick}
                />
              )}
              {buttons?.map((button, index) => (
                <CustomButton key={index} {...button.attr} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
});

ResourceModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  hp: PropTypes.string,
  index: PropTypes.number,
  closeCallback: PropTypes.func,
  isCloseHelp: PropTypes.bool,
  gtm: PropTypes.string,
  image: PropTypes.string,
  promoCode: PropTypes.string,
};

export default ResourceModal;
